/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CheckoutVM { 
    id?: number;
    uuid?: string | null;
    checkoutDate?: string | null;
    returnDate?: string | null;
    checkinDate?: string | null;
    approvedby?: string | null;
    checkedoutfor?: string | null;
    reason?: string | null;
    notes?: string | null;
}

